<template>
  <div class="content">
    <ModalPadrao
      :showModal="showModal"
      :ifSubheadingTop="true"
      :SubheadingTop="'Deseja cancelar Carteira de horas'"
      :ifIcon="true"
      :Icon="'cancel'"
      :ifTwoBtn="true"
      :TextFirstBtn="'Não'"
      :TextSecondBtn="'Sim'"
      @btnUm="showModal = false"
      @btnDois="cancelPromotion(wallet)"
    ></ModalPadrao>
    <BlockUI
      v-if="blockScreen"
      :message="blockScreenData.msg"
      :url="blockScreenData.url"
    ></BlockUI>
    <v-card>
      <v-card-title>
        Carteira de Horas
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Procurar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-flex offset-lg10>
        <download-excel
          class="ml-auto mr-0"
          :data="promotionUser"
          :fields="json_fields"
          name="carteira_de_horas.xls"
        >
          <v-btn small class="mr-4">
            <span class="pr-1">Exportar</span>
            <v-icon small class="black--text">insert_drive_file</v-icon>
          </v-btn>
        </download-excel>
      </v-flex>
      <v-data-table
        no-data-text="Nenhuma carteira registrada"
        footer-props.items-per-page-text="Linhas por página"
        :headers="headers"
        :items="promotionUser"
        :search="search"
        class="table-custom-vue elevation-1 mt-2"
        :rows-per-page-items="[
          10,
          25,
          { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        ]"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class>{{ item.promotion_name }}</td>
            <td class>{{ item.user_name }}</td>
            <td class>{{ item.client_name | formatType }}</td>
            <td class>R$ {{ item.activation_value | formatPrice }}</td>
            <td class>{{ item.hours_per_month }}</td>
            <td class>{{ item.time_spent | formatTime }}</td>
            <td class>{{ item.activation_date | formatDate }}</td>
            <td class>{{ item.active | formatStatus }}</td>
            <td>
              <ActionButton
                v-if="item.active"
                message="Cancelar carteira"
                icon="cancel"
                @onclick="
                  showModal = true;
                  wallet = item;
                "
              />
            </td>
          </tr>
        </template>
      </v-data-table>
      <div
        class="modal fade"
        id="add-coupon"
        tabindex="-1"
        role="dialog"
        aria-labelledby="register-driver-modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content"></div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import MaskHelper from '../../helpers/MaskHelper';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import PromotionUserController from '../../controllers/PromotionUserController';
import moment from 'moment';
import NumberHelper from './../../helpers/NumberHelper';
import ModalPadrao from '../shared/ModalPadrao.vue';
import Breadcrumb from '../shared/Breadcrumb.vue';
import ActionButton from '../shared/ActionButtonsTemplate';

export default {
  created() {
    this.report();
  },
  components: {
    ActionButton,
    ModalPadrao,
    Breadcrumb,
  },
  data() {
    return {
      promotionUserController: new PromotionUserController(this.$resource),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      search: '',
      json_fields: {
        Promoção: 'promotion_name',
        Usuário: 'user_name',
        Cliente: 'client_name',
        'Valor da Ativação': {
          field: 'activation_value',
          callback: (value) => {
            return 'R$ ' + NumberHelper.formatPrice(value);
          },
        },
        'Quantidade de Horas': 'hours_per_month',
        'Tempo utilizado': {
          field: 'time_spent',
          callback: (value) => {
            let min = NumberHelper.convertTimeObjectInMinutes(value);
            let int = parseInt(min / 60);
            let resto = min % 60;
            int = int < 10 ? `0${int}` : int;
            resto = resto < 10 ? `0${resto}` : resto;
            return `${int}:${resto} h`;
          },
        },
        'Data de ativação': {
          field: 'activation_date',
          callback: (value) => {
            if (value) {
              return moment(value).format('DD[/]MM[/]YYYY');
            }
            return value;
          },
        },
        Situação: {
          field: 'active',
          callback: (value) => {
            return value ? 'Ativo' : 'Cancelado';
          },
        },
      },
      headers: [
        { text: 'Promoção', value: 'promotion_name' },
        { text: 'Usuário', value: 'user_name' },
        { text: 'Cliente', value: 'client_name' },
        { text: 'Valor da Ativação', value: 'activation_value' },
        { text: 'Quantidade de Horas', value: 'hours_per_month' },
        { text: 'Tempo utilizado', value: 'time_spent' },
        { text: 'Data de ativação', value: 'activation_date' },
        { text: 'Situação', value: 'active' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      promotionUser: [],
      showModal: false,
      wallet: null,
    };
  },
  methods: {
    report() {
      this.promotionUserController.getWalletHoursReport().then((res) => {
        this.promotionUser = res.body;
      });
    },
    cancelPromotion(wallet) {
      this.showModal = false;
      this.promotionUserController
        .cancelWalletHours(wallet.transaction_id, wallet.client_id)
        .then((res) => {
          this.report();
          this.$awn.success('Oferta desativada com succeso.');
        })
        .catch((error) => {
          this.$awn.alert('Falha ao desativar oferta.');
        });
    },
    details() {
    },
  },
  filters: {
    formatStatus(status) {
      return status ? 'Ativo' : 'Cancelado';
    },
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY');
      }
    },
    formatPrice(price) {
      return NumberHelper.formatPrice(price);
    },
    formatActive(vlr) {
      if (vlr) return 'Ativo';
      else return 'Cancelado';
    },
    formatType(text) {
      switch (text) {
        case 'wallet_hours':
          return 'Carteira de Horas';
          break;
        default:
          return text;
          break;
      }
    },
    formatTime(time) {
      let min = NumberHelper.convertTimeObjectInMinutes(time);
      let int = parseInt(min / 60);
      let resto = min % 60;
      int = int < 10 ? `0${int}` : int;
      resto = resto < 10 ? `0${resto}` : resto;
      return `${int}:${resto} h`;
    },
  },
};
</script>
<style lang="scss">
.radios {
  margin: 5px;
}
.radios input {
  margin-right: 3px;
}
.radios label {
  margin-right: 15px;
}
.table-custom-vue {
  margin: 20px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.table-custom-vue thead tr > th,
.table-custom-vue tbody td {
  text-align: center !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    background: var(--primary-color-hover);
  }
}
.card-header .filter-header {
  background: var(--secondary-color) !important;
}

.import-driver-button,
.new-driver-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
</style>
